export class FindIdP {
    id: number;
    domainNames: string;
    page: number;
    pageSize: number;

    constructor() {
        this.id = 0;
        this.domainNames = '';
        this.page = 1;
        this.pageSize = 10;
    }
}